export const ANIMATION_DEFAULTS = {
  FADE_RATIO: 0.05,
  MIN_OPACITY: 0.3,
  BLUR_MAX: 2,
  BLUR_MIN: 0,
  SMOOTHSTEP_THRESHOLD: 0.99,
}

export const CSS_CLASSES = {
  PARAGRAPH: 'text-tg-body-l text-moss-white lg:text-24 lg:leading-[34px]',
  HEADING: 'lg:text-tg-h2 pb-12 text-32 leading-[normal] tracking-[-.32px] text-moss-white max-lg:pb-12',
  STRONG: 'font-normal text-green-neon',
  ROOT: 'relative prose prose-zinc max-w-none dark:prose-invert flex flex-col gap-2 md:gap-4',
  MOBILE_OVERLAY: 'my-8 md:max-lg:w-fit lg:hidden',
  MOBILE_OVERLAY_HEADING: 'mb-12 mt-6 lg:hidden',
} as const
